// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__1ovaV","active":"NavigationItem_active__WYJUi","Notification":"NavigationItem_Notification__UzZtI"};